export interface NavLink {
  name: string;
  href: string;
  isExternal?: boolean;
}

export const navLinks: NavLink[] = [
  { name: 'Inicio', href: '/' },
  { name: '¿Qué es Unipay?', href: '/sobre-unipay' },
  { name: 'Nueva App', href: '/appunimarc' },
  { name: 'Beneficios', href: '/beneficios' },
  { name: 'Productos', href: '/productos' },
  { name: 'Preguntas frecuentes', href: '/preguntas-frecuentes' },
//  { name: 'Seguros', href: 'https://www.unimarccorredores.cl/', isExternal: true },

  // { name: 'Cómo funciona', href: '/como-funciona' },
  // { name: 'Contacto', href: '/contacto' }
];
